<template>
    <div class="footer">

        <div class="copyright-box">
            Copyright©2022 广州康纳天花有限公司
            <a href="http://beian.miit.gov.cn/" class="filing-box">
                <img src="~@/assets/images/public/gn.gif">粤ICP备13080358号-1
            </a>
        </div>
        <div class="contact-box">
            <i class="icon el-icon-mobile-phone" style="font-size: 15px; margin-right: 5px;"></i>电 话：(020) 87813099 87813859  &nbsp;&nbsp;&nbsp; <i class="icon icon spa-font spa-email"></i>Email：canr2008@163.com
        </div>
        <div class="link-box">
            <app-link to="/suggest">建议反馈</app-link> <span class="line">-</span>
            <app-link to="/about">关于我们</app-link>
        </div>
    </div>
</template>

<script>
import AppLink from "@/components/common/link";
const page = {
    props: {},
    components: { AppLink },
};
export default page;
</script>

<style lang="scss" scoped>
.footer {
    margin-top: 20px;
    padding-top: 50px;
    padding-bottom: 50px;
    background-color: #2a2730;
    color: #99979c;
    width: 100%;
    min-width: 1200px;
    clear: both;
    text-align: center;
}

.footer .link-box {
    margin-top: 30px;
}

.footer .link-box .line {
    margin-left: 10px;
    margin-right: 10px;
}

.footer .contact-box {
    margin-top: 30px;
}

.footer .contact-box .icon {
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 12px;
    margin-right: 10px;
}

.footer .copyright-box {
    text-align: center;
    font-size: 13px;
}

.footer .copyright-box .filing-box {
    color: #99979c;
}

@media screen and (max-width: 767px) {
    .footer {
        min-width: auto;
    }
}

@media screen and (max-width: 768px) and (min-width: 767px) {
    .footer {
        min-width: auto;
        padding: 0 15px;
    }
}
</style>


// WEBPACK FOOTER //
// src/layout/app/components/footer/index.vue